import { Dropdown, Button } from "prism-react";
import { useState } from "react";

import { AnimatedDiv } from "./AnimatedDiv";
import { useTitleState } from "./useTitleState";

export const TitleMenu: React.FC<{
  canRename: boolean;
  isInteractive: boolean;
  children: React.ReactNode;
}> = ({ children, canRename, isInteractive }) => {
  const [branchMenuOpen, setBranchMenuOpen] = useState(false);
  const { showRenameForm, setShowRenameForm } = useTitleState();

  return (
    <AnimatedDiv
      css={{
        pointerEvents: showRenameForm ? "none" : "auto",
      }}
    >
      <Dropdown
        experimentalOnCloseAutoFocus={(ev) => ev.preventDefault()}
        rootProps={{
          onOpenChange: (open) => setBranchMenuOpen(open),
          open: branchMenuOpen,
        }}
        trigger={
          <Button
            css={{
              minWidth: "$5",
              padding: 0,
              marginRight: "-$1",
              opacity: isInteractive ? 1 : 0,
              color:
                "var(--vscode-titleBar-inactiveForeground, $neutral-fg-base)",

              span: {
                transition: "transform $fast, color $fast",
                color: branchMenuOpen
                  ? "$neutral-fg-subtle"
                  : "var(--vscode-titleBar-inactiveForeground, $neutral-fg-base)",
                transform: `translateY(${branchMenuOpen ? 2 : 1}px)`,
              },

              "&:hover span, &:focus span": {
                color: "$neutral-fg-subtle",
                transform: "translateY(3px)",
              },
            }}
            disabled={showRenameForm}
            icon="chevronSmallDown"
          />
        }
      >
        {canRename && (
          <>
            <Dropdown.Item
              onSelect={(e) => {
                e.stopPropagation();
                setShowRenameForm(true);
              }}
            >
              Rename
            </Dropdown.Item>

            <Dropdown.Separator />
          </>
        )}

        {children}
      </Dropdown>
    </AnimatedDiv>
  );
};
